/*
 * Copyright 2019 FedEx
 */
export const common = {
  GB_DESCI_URL: "https://internationalshippingassist.van.fedex.com/en-gb",
  ROLLED_OUT_COUNTRIES: ['AE', 'DE', 'FR', 'GB', 'IE', 'NL', 'ZA'],
  IMPNO_PRIVATE_ELIGIBLE_COUNTRIES: ['GB','ZA'],
};